import { RouterProvider } from "@tanstack/react-router";
import { paymentsUiRouter } from "./paymentsUiRouter";

export const Navigation = () => <RouterProvider router={paymentsUiRouter} />;
